import type { Client } from '../types'

const DEMO_SIGNATURES = new Set([
  'ооо «вектор»|+7 999 120-42-10',
  'электроснаб|+7 926 455-18-27',
  'ао «горизонт»|+7 495 602-11-30',
  'монтажпроект|+7 903 719-03-44',
  'технолайн|+7 916 100-55-08',
  'ип соколов|+7 985 010-88-41',
])

function demoSignature(client: Pick<Client, 'company' | 'phone'>): string {
  return `${client.company.trim().toLocaleLowerCase('ru')}|${client.phone.trim()}`
}

export function isDemoClient(client: Pick<Client, 'id' | 'company' | 'phone'>): boolean {
  return client.id.startsWith('demo-') || DEMO_SIGNATURES.has(demoSignature(client))
}

export function prepareClientForPersistence(client: Client): Client {
  if (client.status !== 'new' || client.attempts === 0) return client

  return {
    ...client,
    status: 'contacted',
    interactions: client.interactions.map((interaction, index) =>
      index === 0 && interaction.status === 'new'
        ? { ...interaction, status: 'contacted' }
        : interaction,
    ),
  }
}

export function persistentClients(clients: Client[]): Client[] {
  return clients
    .filter((client) => !isDemoClient(client))
    .map(prepareClientForPersistence)
}
